<template>
    <div class="w-100 h-100">
        <div class="d-flex flex-column align-items-center justify-content-center h-100 w-100">
             <div>
                
            </div>
           <!--  <div>
                <a href="#/map" type="primary">Proceed to Map</a>
            </div> -->
            <el-button size="large" class="primaryGradient text-white rounded" @click="moveToMap">
                {{ time + " BẮT ĐẦU THAM QUAN" }}
            </el-button>
        </div>
    </div>
</template>
<script>
import router from "@/router";
import { defineComponent, onMounted, ref } from "vue";
export default defineComponent({
    name: "dashboard",
    data() {
        return {
            time: 10,
        };
    },
    methods: {
        async moveToMap() {
            const currentQuery = await this.$route.query
            router.push({
                path: '/map',
                query: currentQuery
            })
        },
         async handleCountDown() {
            while (this.time > 0) {
                await this.delay(1000).then(() => {
                    this.time--
                    if(this.time == 0){
                        this.moveToMap()
                    }
                })
            }
        },
        delay(time) {
            return new Promise((resolve) => setTimeout(resolve, time))
        }
    },
    mounted(){
        this.time = 10
        this.handleCountDown()
    }
})
</script>
<style></style>